import './table-attendance.scss';
//react
import format from 'date-fns/format';
//shared
import { DataNotFound } from '../../../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from './constants/DataNotFound';
import ICalendar from '../../../shared/interfaces/calendar.interface';
//material
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { IconButton } from '@mui/material';

export const TableAttendance = ({ tableData, takeAttendance }: {tableData: Array<any>, takeAttendance: (calendar: ICalendar) => void}) => {

    if(!tableData.length) return <DataNotFound data={DATA_NOT_FOUND} />;
    return (
        <TableContainer className='container-table' component={Paper}>
            <Table sx={{ minWidth: 250 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Clase</TableCell>
                        <TableCell align="center">Fecha</TableCell>
                        <TableCell align="center">Hora</TableCell>
                        <TableCell align="center">Asistencia</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row: any) => (
                        <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell align="center" component="th" scope="row">{row.classFit.name}</TableCell>
                            <TableCell align="center">{format(new Date(row.start), "dd/MM/yyyy")}</TableCell>
                            <TableCell align="center">{format(new Date(row.start), "HH:mm")}</TableCell>
                            <TableCell align="center">
                                <IconButton onClick={() => takeAttendance(row)}>
                                    <BorderColorIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}